// extracted by css-extract-rspack-plugin
export default {"navigationMenuItem":"navigationMenuItem-hDEzzC","navigationMenuDiffIndicator":"navigationMenuDiffIndicator-NKuRti"};